import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCommentRed = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.8 4.5H5.2C4.54 4.5 4 5.04 4 5.7V12.9C4 13.56 4.54 14.1 5.2 14.1H13.1858C13.451 14.1 13.7054 14.2054 13.8929 14.3929L15.1464 15.6464C15.4614 15.9614 16 15.7383 16 15.2929V5.7C16 5.04 15.46 4.5 14.8 4.5Z",
		fill: "#FF85C0"
	})
});
const ForwardRef = forwardRef(SvgCommentRed);
export { ForwardRef as ReactComponent };
